import Vue from "vue";
import Vuex from "vuex";
import cache from "@/plugins/cache.js";
import authService from "@/services/authService.js";
import identityUserService from "@/services/master/identity/identityUserService.js";

Vue.use(Vuex);

const PROFILE_KEY = "mavprofile";
const TOKEN_KEY = "mavtokenkey";
const USER_KEY = "mavuserkey";
const STORE_PROFILE = "STORE_PROFILE";
const REMOVE_PROFILE = "REMOVE_PROFILE";
const STORE_TOKEN = "STORE_TOKEN";
const REMOVE_TOKEN = "REMOVE_TOKEN";
const STORE_USER = "STORE_USER";
const REMOVE_USER = "REMOVE_USER";
const auth = new authService();

const mutations = {
  [STORE_PROFILE]: (state, profile) => {
    const encodedProfile = btoa(
      unescape(encodeURIComponent(JSON.stringify(profile)))
    );
    cache.set(PROFILE_KEY, encodedProfile, 300000); // 5 mins
  },
  [REMOVE_PROFILE]: state => {
    cache.remove(PROFILE_KEY);
  },
  [STORE_TOKEN]: (state, token) => {
    const timeNow = new Date().getTime();
    const timeDiff = token.user.exp * 1000 - timeNow;
    const encodedToken = btoa(
      unescape(encodeURIComponent(JSON.stringify(token)))
    );
    cache.set(TOKEN_KEY, encodedToken, timeDiff);
  },
  [REMOVE_TOKEN]: state => {
    cache.remove(TOKEN_KEY);
  },
  [STORE_USER]: (state, user) => {
    const timeNow = new Date().getTime();
    const timeDiff = user.exp * 1000 - timeNow;
    const encodedUser = btoa(
      unescape(encodeURIComponent(JSON.stringify(user)))
    );
    cache.set(USER_KEY, encodedUser, timeDiff);
  },
  [REMOVE_USER]: state => {
    cache.remove(USER_KEY);
  }
};

const actions = {
  getUser: async ({ commit }) => {
    try {
      // get from cache
      let user = cache.get(USER_KEY);
      if (user !== undefined && user !== null && user !== "") {
        const decodedUser = JSON.parse(decodeURIComponent(escape(atob(user))));
        if (decodedUser) {
          return decodedUser;
        }
      }

      // clean storage
      commit(REMOVE_USER);

      // get from API
      user = await auth.getUser();

      // store to local storage
      commit(STORE_USER, user);

      return user;
    } catch (error) {
      commit(REMOVE_USER);
      throw new Error(error);
    }
  },
  removeUser: ({ commit }) => {
    try {
      // clean storage
      commit(REMOVE_USER);
    } catch (error) {
      throw new Error(error);
    }
  },
  getProfile: async ({ dispatch, commit }) => {
    try {
      // const currentUser = await auth.getUser()
      const currentUser = await dispatch("getUser");

      // get from cache
      let profile = cache.get(PROFILE_KEY);
      if (profile && profile !== "") {
        const decodedProfile = JSON.parse(
          decodeURIComponent(escape(atob(profile)))
        );
        if (decodedProfile && decodedProfile.id === currentUser.profile.sub) {
          return decodedProfile;
        }
      }

      // clean storage
      commit(REMOVE_PROFILE);

      // get from API
      profile = await identityUserService.getProfile();
      commit(STORE_PROFILE, profile);

      return profile;
    } catch (error) {
      commit(REMOVE_PROFILE);
      throw new Error(error);
    }
  },
  removeProfile: ({ commit }) => {
    try {
      // clean storage
      commit(REMOVE_PROFILE);
    } catch (error) {
      throw new Error(error);
    }
  },
  getToken: async ({ commit }) => {
    try {
      // get from cache
      let accessToken = cache.get(TOKEN_KEY);
      if (
        accessToken !== undefined &&
        accessToken !== null &&
        accessToken !== ""
      ) {
        const decodedAccessToken = JSON.parse(
          decodeURIComponent(escape(atob(accessToken)))
        );
        if (decodedAccessToken.token) {
          return decodedAccessToken.token;
        }
      }

      // clean storage
      commit(REMOVE_TOKEN);

      // get from API
      accessToken = await auth.getAcessToken();

      // store to local storage
      commit(STORE_TOKEN, accessToken);

      return accessToken.token;
    } catch (error) {
      commit(REMOVE_TOKEN);
      throw new Error(error);
    }
  },
  removeToken: ({ commit }) => {
    try {
      // clean storage
      commit(REMOVE_TOKEN);
    } catch (error) {
      throw new Error(error);
    }
  }
};

export default {
  namespaced: true,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/user.js